var _desc, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogout(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "18px",
    viewBox: "0 0 20 18",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "logout") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Dashboards-v1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Dashboard---Nav-Tray",
    transform: "translate(-878.000000, -378.000000)",
    fill: "#A28C62"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Nav-Tray",
    transform: "translate(853.000000, -61.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-18"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-17"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-11"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M40.3688218,453.755648 C40.0275635,454.081451 39.4729826,454.081451 39.1309206,453.755648 C38.7896622,453.43063 38.7896622,452.903208 39.1309206,452.577424 L42.01231,449.833162 L31.8749047,449.833162 C31.3927912,449.833162 31,449.460614 31,448.999895 C31,448.53994 31.3927706,448.166627 31.8749047,448.166627 L42.01231,448.166627 L39.1309206,445.42315 C38.7896622,445.097347 38.7896622,444.569944 39.1309206,444.244926 C39.4730032,443.918358 40.0275635,443.918358 40.3688218,444.244926 L44.7432423,448.411165 C44.9146813,448.573678 45,448.786794 45,448.999895 C45,449.21376 44.9146833,449.42688 44.7432423,449.589389 L40.3688218,453.755648 Z M32,456.181888 C32,456.634228 31.6087905,457 31.125796,457 L27.6250236,457 C27.2724528,457 26.9295257,456.936027 26.6067326,456.810336 C26.2944079,456.68841 26.014272,456.513792 25.7735784,456.291022 C25.5312775,456.068253 25.3412985,455.807835 25.2076806,455.518073 C25.0700299,455.216269 25,454.896392 25,454.566747 L25,441.454336 C25,441.123939 25.0700319,440.802559 25.2068769,440.498501 C25.3388916,440.207236 25.5280627,439.944564 25.7687563,439.719521 C26.0094498,439.494478 26.2895652,439.317623 26.6035178,439.193425 C26.9271147,439.064725 27.2708455,439 27.6250236,439 L31.125796,439 C31.6087905,439 32,439.366523 32,439.818112 C32,440.270452 31.6087905,440.636224 31.125796,440.636224 L27.6250236,440.636224 C27.1420291,440.636224 26.7500153,441.004269 26.7500153,441.454336 L26.7500153,454.566747 C26.7500153,455.006274 27.1420291,455.36378 27.6250236,455.36378 L31.125796,455.36378 C31.6087905,455.36378 32,455.730303 32,456.181892 L32,456.181888 Z",
    id: "logout"
  })))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogout);
export default __webpack_public_path__ + "static/media/logout.c1ca0b2cc1ab567a6d0c27b6bbcae780.svg";
export { ForwardRef as ReactComponent };